import { Popover } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

/** (i) next to the compound's «Inflect template (optional)» select: how the compound's active cells are chosen. */
const CompoundInflectTemplateInfo: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <InfoButton
        type="button"
        title="How the compound's inflect template works"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        i
      </InfoButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Content>
          <Title>Which forms does the compound generate?</Title>
          <p>
            <b>From panels (intersection)</b> — default. The compound generates only the cells that are active in{' '}
            <b>all</b> the inflect templates of its member panels.
          </p>
          <p>
            <b>A template</b> — the compound generates exactly the cells of that template, and its panels&apos;
            templates are ignored. Use it when the panels&apos; templates share no cell, e.g. a panel for the plural
            possessive (<i>arkadaşlarımız</i>) and a panel for the dative possessive (<i>arkadaşımıza</i>): the compound{' '}
            <i>arkadaşlarımıza</i> needs a template with that one cell.
          </p>
          <p>
            Only templates of the compound&apos;s word class are listed. After changing it, cells outside the new
            template are removed; the new ones appear on the next <b>Inflect</b>.
          </p>
        </Content>
      </Popover>
    </>
  );
};

const InfoButton = styled.button`
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  margin-left: 8px;
  padding: 0;
  border: 1px solid #1976d2;
  border-radius: 50%;
  background: #fff;
  color: #1976d2;
  font: italic bold 13px/20px Georgia, serif;
  cursor: pointer;
  align-self: center;

  &:hover {
    background: #e3f2fd;
  }
`;

const Content = styled.div`
  max-width: 420px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.45;

  p {
    margin: 6px 0;
  }
`;

const Title = styled.div`
  font-weight: bold;
  margin-bottom: 4px;
`;

export default CompoundInflectTemplateInfo;
